import type { GetNavigationQueryResult } from "@/sanity.types";

import { SiteHeaderMobileMenuColumns } from "./siteHeaderMobileMenuColumns.component";
import {
  findNavigationGroupByKey,
  getFeaturedItems,
  hasNestedColumns,
} from "./siteHeaderMobileMenuContent.utils";
import { SiteHeaderMobileMenuFeaturedItem } from "./siteHeaderMobileMenuFeaturedItem.component";
import { SiteHeaderMobileMenuRootOrFlatLinks } from "./siteHeaderMobileMenuRootOrFlatLinks.component";

export { findNavigationGroupByKey } from "./siteHeaderMobileMenuContent.utils";

export const SiteHeaderMobileMenuContent = ({
  menu,
  selectedMenu,
  setSelectedMenu,
}: SiteHeaderMobileMenuContentProps) => {
  const foundMenu = selectedMenu
    ? findNavigationGroupByKey(menu?.items, selectedMenu)
    : undefined;
  const featuredItems = getFeaturedItems(foundMenu);
  const showStackedColumns = Boolean(foundMenu && hasNestedColumns(foundMenu));

  return (
    <nav data-testid="site-header-mobile-menu-content">
      {featuredItems?.length ? (
        <ul
          data-testid="site-header-mobile-menu-featured-items"
          className="flex flex-wrap gap-4 p-6">
          {featuredItems.map((item) => (
            <SiteHeaderMobileMenuFeaturedItem key={item._key} item={item} />
          ))}
        </ul>
      ) : null}
      <div
        className="flex flex-col border-t border-black/10 p-6"
        data-testid="site-header-mobile-menu-menu-links">
        {showStackedColumns && foundMenu ? (
          <SiteHeaderMobileMenuColumns items={foundMenu.items ?? []} />
        ) : (
          <SiteHeaderMobileMenuRootOrFlatLinks
            items={foundMenu?.items ?? menu?.items ?? []}
            setSelectedMenu={setSelectedMenu}
          />
        )}
      </div>
    </nav>
  );
};

export type SiteHeaderMobileMenuContentProps = {
  menu?: GetNavigationQueryResult;
  selectedMenu?: string;
  setSelectedMenu: (menu: string) => void;
};
